import Capability from './Capability';
import React from 'react';
import styles from './styles.module.css';

type Item = {
  _key: string;
  title?: string;
  capabilityCta?: Record<string, unknown>;
  description?: string;
  content?: Record<string, unknown>[];
  image?: Record<string, unknown>;
  bgColor?: {
    hex: string;
  };
  textColor?: {
    hex: string;
  };
  underline: {
    color?: {
      hex: string;
    };
    width?: number;
  };
};

interface CapabilitiesProps {
  heading: string;
  alignment?: string;
  bgColor?: {
    hex: string;
  };
  textColor?: {
    hex: string;
  };
  items?: Item[];
}

const Capabilities: React.FC<CapabilitiesProps> = ({ heading, alignment = 'left', bgColor, textColor, items }) => {
  const wrapperRef = React.useRef(null);

  React.useEffect(() => {
    if (bgColor?.hex) {
      wrapperRef.current.style.setProperty('--bgColor', `${bgColor.hex}`);
    }
    if (textColor?.hex) {
      wrapperRef.current.style.setProperty('--fontColor', `${textColor.hex}`);
    }
  }, [wrapperRef, bgColor, textColor]);

  return (
    <section ref={wrapperRef} className={styles.wrapper}>
      <div className={styles.capabilities}>
        <div className={styles[alignment]}>
          <h2 className={styles.heading}>{heading}</h2>
        </div>
        {items.length > 0
          ? items.map((item) => (
              <Capability
                key={item._key}
                heading={item.title}
                cta={item.capabilityCta}
                description={item.description}
                textContent={item.content}
                bgColor={item.bgColor}
                textColor={item.textColor}
                underline={item.underline}
                image={item.image}
              />
            ))
          : null}
      </div>
    </section>
  );
};

export default Capabilities;
